export const HIERARCHY_FIELDS = [
  "region",
  "office",
  "division",
  "section",
  "unit",
  "cluster",
];

export const HIERARCHY_COLLECTIONS = {
  region: "Region",
  office: "offices",
  division: "Division",
  section: "Sections",
  unit: "Units",
  cluster: "Clusters",
};

export function getHierarchyFetchTarget(hierarchyWhere) {
  if (!hierarchyWhere || typeof hierarchyWhere !== "object") {
    return null;
  }

  for (const field of HIERARCHY_FIELDS) {
    const id = hierarchyWhere[field];
    if (id) {
      return {
        field,
        id,
        collection: HIERARCHY_COLLECTIONS[field],
      };
    }
  }

  return null;
}

export async function fetchHierarchyItem(
  findObjectUseCase,
  source,
  { keys = ["name"], pointerPrefix = "" } = {},
) {
  const hierarchyWhere = buildHierarchyWhere(source, pointerPrefix);
  const target = getHierarchyFetchTarget(hierarchyWhere);

  if (!target?.collection || !target?.id) {
    return [];
  }

  return findObjectUseCase.execute(target.collection, {
    where: { id: target.id },
    keys,
  });
}

export function getLastNonEmptyField(source, fields = HIERARCHY_FIELDS) {
  let result = "";
  let index = -1;

  if (!source) {
    return { result, index };
  }

  fields.forEach((field, i) => {
    if (source[field] && source[field] !== "") {
      result = source[field];
      index = i;
    }
  });

  return { result, index };
}

export function buildHierarchyWhere(source, pointerPrefix = "", fields = HIERARCHY_FIELDS) {
  const { result, index } = getLastNonEmptyField(source, fields);
  if (index === -1) {
    return {};
  }

  const field = fields[index];
  const key = pointerPrefix ? `${pointerPrefix}.${field}` : field;
  return { [key]: result };
}

export async function findCurrentUserEmployee(
  findObjectUseCase,
  user,
  { keys = HIERARCHY_FIELDS } = {},
) {
  const employeeId = user?.employee?.id;
  if (!employeeId) {
    return [];
  }

  return findObjectUseCase.execute("employees", {
    where: { id: employeeId },
    keys,
  });
}
